import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { filter } from "rxjs/operators";

import { AppEvent, AppEventType } from "../models/app-event/app-event.models";

@Injectable()
export class AppEventQueueService {
	private eventBrocker$ = new Subject<AppEvent<any>>();

	on(eventType: AppEventType): Observable<AppEvent<any>> {
		return this.eventBrocker$.pipe(filter(event => event.type === eventType));
	}

	dispatch<T>(event: AppEvent<T>): void {
		this.eventBrocker$.next(event);
	}
}
